import '@fontsource-variable/inter'
import '../components/App.css'

import { ApolloProvider } from '@apollo/client'
import { ChakraProvider } from '@chakra-ui/react'
import { browserTracingIntegration } from '@sentry/browser'
import * as Sentry from '@sentry/react'
import { extend } from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { AppProps } from 'next/app'

import { AdminWrapper } from '~/components/AdminWrapper'
import { AuthWrapper } from '~/components/AuthWrapper'
import { ErrorBoundary } from '~/components/ErrorBoundary'
import { FirmWrapper } from '~/components/FirmWrapper'
import { FrigadeAssistantWrapper } from '~/components/FrigadeAssistantWrapper'
import { LogRocketWrapper } from '~/components/LogRocketWrapper'
import { PylonWrapper } from '~/components/PylonWrapper'
import { apolloClient, ToastComponent } from '~/data/apollo'
import { theme } from '~/theme/theme'
import { Z_INDEX_PORTAL } from '~/theme/zIndex'
import 'react-day-picker/dist/style.css'
import '~/util/agGrid'

extend(isBetween)

Sentry.init({
  dsn: 'https://66ee286b107c4231b96275d756c12531@o4504469882470400.ingest.sentry.io/4504469888958464',
  integrations: [browserTracingIntegration()],
  tracesSampleRate: 0,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
})

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ChakraProvider resetCSS theme={theme} cssVarsRoot="body" portalZIndex={Z_INDEX_PORTAL}>
      <ApolloProvider client={apolloClient}>
        <ErrorBoundary>
          <AuthWrapper>
            <FirmWrapper>
              <AdminWrapper>
                <LogRocketWrapper>
                  <PylonWrapper>
                    <FrigadeAssistantWrapper>
                      <Component {...pageProps} />
                      <ToastComponent />
                    </FrigadeAssistantWrapper>
                  </PylonWrapper>
                </LogRocketWrapper>
              </AdminWrapper>
            </FirmWrapper>
          </AuthWrapper>
        </ErrorBoundary>
      </ApolloProvider>
    </ChakraProvider>
  )
}

export default MyApp
